/**
 * @desc 查询指定国家起征点
 */
const URL = "/rantion-tms";
import http, { updateResponse } from "@/http";
export type Response = defs.tms.ResponseDto<defs.tms.TariffThresholdResponseDto>;
export function request(countryCode: string | number, options?: any): Promise<Response> {
  return updateResponse(
    http(URL + `/tariffThreshold/byCountry/${countryCode}`, {
      method: "GET",

      ...options,
    }),
  );
}
